import React, { useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Chip, Stack, Button } from '@mui/material';
import { Check, Spa } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FacturationBeaute = () => {
  const navigate = useNavigate();

  const goToRegisterTracked = () => {
    const params = new URLSearchParams({
      utm_source: 'site_facteio',
      utm_medium: 'cta',
      utm_campaign: 'facturation_beaute',
      utm_content: 'cta_page'
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    document.title = 'Logiciel devis facture beauté | Facteio';
    const description = 'Facturation pour la beauté: onglerie, cils, massages, institut. Modèles pose gel/extension cils, TVA désactivée par défaut.';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, []);

  return (
    <Box sx={(theme) => ({ background: theme.palette.background.default, minHeight: '100vh', py: 5 })}>
      <Container maxWidth="lg">
        <Button variant="text" onClick={() => navigate('/')} sx={{ mb: 2, fontWeight: 600 }}>← Retour à l'accueil</Button>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
          <Chip icon={<Spa />} label="Facturation Beauté" sx={{ bgcolor: '#E5E8EE', color: '#1F2937' }} />
          <Chip icon={<Check />} label="Discours adapté beauté" />
          <Chip icon={<Check />} label="SEO + Ads ciblées" />
        </Stack>

        <Typography variant="h3" fontWeight={800} mb={1}>Facturer en beauté, sans complexité</Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Onglerie, institut, massages, coiffeur, pose de cils: un parcours rapide, clair et adapté à la réalité du salon.
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Fonctionnalités ciblées Beauté</Typography>
              <Typography>• Modèles “Pose gel” et “Extension cils”</Typography>
              <Typography>• Pas de TVA activée par défaut</Typography>
              <Typography>• Facture simple ultra rapide</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Acquisition ciblée</Typography>
              <Typography>• Positionnement esthétique/spa/onglerie</Typography>
              <Typography>• Promesse orientée gain de temps cabine</Typography>
              <Typography>• Structure prête pour campagnes Ads locales</Typography>
            </CardContent></Card>
          </Grid>
        </Grid>

        <Card sx={{ mt: 4, border: '1px solid #D5CDC3' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h5" fontWeight={800} mb={1}>
              Facturez entre deux clientes, en quelques clics
            </Typography>
            <Typography color="text.secondary" mb={2}>
              Pas de paramétrage compliqué: modèles beauté prêts à l’emploi et TVA 0% facile à gérer.
            </Typography>
            <Button
              variant="contained"
              sx={{ background: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)' }}
              onClick={goToRegisterTracked}
            >
              Essayer Facteio pour la Beauté
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default FacturationBeaute;
